import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { PurchaseConfirmationPageTranslation } from "@swo/storefront";
import { Wrapper } from "./shared-components/wrapper";
import cn from "classnames";
import { PaymentStatusError } from "./payment-status-error";
import React from "react";
import type { Translated } from "../../../domain/translations/translations";

export const ErrorPage: ReactTFC<{
  homepageLink: string;
  t: Translated<PurchaseConfirmationPageTranslation>;
}> = props => (
  <Wrapper className={cn("expand fill-screen")}>
    <PaymentStatusError
      homepageLink={props.homepageLink}
      t={props.t}
      message={props.t("errorOccurred.paragraph")}
      cardHolderInfo={undefined}
      retryPayment={undefined}
    />
  </Wrapper>
);
